import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';

import Login from './Login';
import Signup from './Signup';
import Home from './Home';
import ForgetPassword from './ForgetPassword';
import FastFoodPage from './FastFoodPage';
import QrCodeDisplay from './QrCodeDisplay';
import QrForm from './QrForm';
import StandardQrForm from './StandardQrForm';
import OrderDetails from './OrderDetails';
import SpinWheel from './SpinWheel';
import VendorPortfolio from './VendorPortfolio';
import CosmeticPage from './CosmeticPage';
import OrdersReceived from './OrdersReceived';
import TypeWithCustomer from './TypeWithCustomer';
import GarmentsPage from './GarmentsPage';
import VendorPaymentCenter from './VendorPaymentCenter';
import DeliveryBoyApp from './DeliveryBoyApp';
import AboutUs from './AboutUs';
import PrintPreview from './PrintPreview';

// SUBSCRIPTION & BILLING PAGE
import SubscriptionPayment from './SubscriptionPayment';

// CUSTOMER APP PAGES
import FoodRadarHomePage from './customer/FoodRadarHomePage';
import FoodRadarOffers from './customer/FoodRadarOffers';
import FoodRadarOrderForm from './customer/FoodRadarOrderForm';
import FoodRadarRewards from './customer/FoodRadarRewards';
import FoodRadarNotificationPicks from './customer/FoodRadarNotificationPicks';
import FoodRadarForegroundNotification from './customer/FoodRadarForegroundNotification';

// STAFF LOGIN PAGE
import StaffLogin from './StaffLogin';

// GROCERY PAGES
import GroceryRetailPage from './GroceryRetailPage';
import GroceryWholesalePage from './GroceryWholesalePage';

// NEW ADMIN PAGES
import AdminSignup from './AdminSignup';
import AdminLogin from './AdminLogin';
import AdminRazorpayPanel from './AdminRazorpayPanel';

// VAKRA CONTROL CENTER
import VakraControlCenterHome from './controlCenter/VakraControlCenterHome';
import ControlCenterLogin from './controlCenter/ControlCenterLogin';
import ControlCenterProtectedRoute from './controlCenter/ControlCenterProtectedRoute';
import ControlCenterDashboard from './controlCenter/ControlCenterDashboard';
import ControlCenterVendors from './controlCenter/ControlCenterVendors';
import ControlCenterSubscriptions from './controlCenter/ControlCenterSubscriptions';
import ControlCenterPayments from './controlCenter/ControlCenterPayments';
import ControlCenterAgreements from './controlCenter/ControlCenterAgreements';

// SMART OFFER DIGEST
import ControlCenterSmartDigest from './controlCenter/ControlCenterSmartDigest';

// CONTROL CENTER NOTIFICATIONS
import ControlCenterNotifications from './controlCenter/ControlCenterNotifications';

// CAKE PLATFORM
import CakeLandingPage from './cake/CakeLandingPage';
import CakeSignup from './cake/CakeSignup';
import CakeLogin from './cake/CakeLogin';
import CakeBookDemo from './cake/CakeBookDemo';
import CakeVendorHome from './cake/CakeVendorHome';
import CakeProducts from './cake/CakeProducts';
import CakeAddProduct from './cake/CakeAddProduct';
import CakePublicShop from './cake/CakePublicShop';
import CakeCheckout from './cake/CakeCheckout';
import CakeOrders from './cake/CakeOrders';
import CakeSettings from './cake/CakeSettings';

// PUBLIC NAVBAR
import HomePage from './components/HomePage';

// ROOT DOMAIN / SUBDOMAIN CHECK
const RootRoute = () => {
  const hostname = window.location.hostname.toLowerCase();

  if (
    hostname === 'control.vakra.co.in' ||
    hostname === 'www.control.vakra.co.in'
  ) {
    return <VakraControlCenterHome />;
  }

  if (
    hostname === 'cake.vakra.co.in' ||
    hostname === 'www.cake.vakra.co.in'
  ) {
    return <CakeLandingPage />;
  }

  return <Home />;
};

const ContactPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <HomePage />

      <main
        style={{
          padding: '110px 20px 70px',
          maxWidth: '1050px',
          margin: '0 auto',
          fontFamily: 'Inter, system-ui, sans-serif',
        }}
      >
        <section
          style={{
            background: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '24px',
            padding: '40px',
            boxShadow: '0 12px 35px rgba(15, 23, 42, 0.08)',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '24px',
              flexWrap: 'wrap',
            }}
          >
            <div
              style={{
                width: '72px',
                height: '72px',
                minWidth: '72px',
                borderRadius: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px',
                background: '#eef4ff',
              }}
            >
              ✉️
            </div>

            <div style={{ flex: '1 1 280px' }}>
              <span
                style={{
                  color: '#2563eb',
                  fontSize: '14px',
                  fontWeight: '700',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Need Help?
              </span>

              <h1
                style={{
                  margin: '6px 0 10px',
                  fontSize: '2rem',
                  color: '#111827',
                }}
              >
                Contact Us
              </h1>

              <p
                style={{
                  textAlign: 'left',
                  fontSize: '1rem',
                  lineHeight: '1.7',
                  color: '#64748b',
                  margin: '0 0 16px',
                }}
              >
                Have a question or need help with VAKRA? Our support team is here
                to assist you.
              </p>

              <a
                href="mailto:support@vakra.co.in"
                style={{
                  display: 'inline-block',
                  color: '#2563eb',
                  fontSize: '18px',
                  fontWeight: '700',
                  textDecoration: 'none',
                  wordBreak: 'break-word',
                }}
              >
                support@vakra.co.in
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

const InvalidQrPage = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        background: '#f8fafc',
        fontFamily: 'Inter, system-ui, sans-serif',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '420px',
          background: '#ffffff',
          border: '1px solid #e5e7eb',
          borderRadius: '20px',
          padding: '28px 22px',
          textAlign: 'center',
          boxShadow: '0 18px 45px rgba(15, 23, 42, 0.12)',
        }}
      >
        <div
          style={{
            width: '70px',
            height: '70px',
            borderRadius: '50%',
            background: '#fee2e2',
            color: '#dc2626',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px',
            fontSize: '34px',
            fontWeight: '800',
          }}
        >
          !
        </div>

        <h1
          style={{
            margin: '0 0 10px',
            color: '#111827',
            fontSize: '1.7rem',
          }}
        >
          Invalid QR Code
        </h1>

        <p
          style={{
            margin: '0 0 8px',
            color: '#475569',
            fontSize: '1rem',
            lineHeight: '1.6',
          }}
        >
          Ye QR code valid nahi hai ya system me registered nahi hai.
        </p>

        <p
          style={{
            margin: 0,
            color: '#64748b',
            fontSize: '0.92rem',
            lineHeight: '1.5',
          }}
        >
          Please restaurant ke table par laga hua correct QR code scan karein.
        </p>
      </div>
    </div>
  );
};


const VendorPublicLinkResolver = () => {
  const { shopKey = '' } = useParams();
  const [checking, setChecking] = React.useState(true);
  const [isCake, setIsCake] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;

    const resolveShop = async () => {
      try {
        const response = await fetch(
          `/api/public/vendor-links/resolve/${encodeURIComponent(shopKey)}`
        );

        const data = await response.json().catch(() => ({}));

        if (
          response.ok &&
          data?.success !== false &&
          data?.targetPath
        ) {
          window.location.replace(data.targetPath);
          return;
        }

        if (!cancelled) {
          setIsCake(true);
          setChecking(false);
        }
      } catch (error) {
        console.error('Vendor short-link resolve error:', error);

        if (!cancelled) {
          setIsCake(true);
          setChecking(false);
        }
      }
    };

    resolveShop();

    return () => {
      cancelled = true;
    };
  }, [shopKey]);

  if (checking) {
    return <div style={{ padding: '20px' }}>Loading...</div>;
  }

  if (isCake) {
    return <CakePublicShop />;
  }

  return null;
};

function App() {
  return (
    <BrowserRouter>
      {window.location.pathname.startsWith('/food-radar') && (
        <FoodRadarForegroundNotification />
      )}

      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<RootRoute />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/ForgetPassword" element={<ForgetPassword />} />

        {/* VENDOR SUBSCRIPTION & BILLING */}
        <Route
          path="/subscription-billing"
          element={<SubscriptionPayment />}
        />

        {/* VAKRA CONTROL CENTER PUBLIC ROUTES */}
        <Route
          path="/control-center"
          element={<VakraControlCenterHome />}
        />

        <Route
          path="/control-center/login"
          element={<ControlCenterLogin />}
        />

        {/* VAKRA CONTROL CENTER PROTECTED ROUTES */}
        <Route element={<ControlCenterProtectedRoute />}>
          <Route
            path="/control-center/dashboard"
            element={<ControlCenterDashboard />}
          />

          <Route
            path="/control-center/vendors"
            element={<ControlCenterVendors />}
          />

          <Route
            path="/control-center/subscriptions"
            element={<ControlCenterSubscriptions />}
          />

          <Route
            path="/control-center/payments"
            element={<ControlCenterPayments />}
          />

          <Route
            path="/control-center/agreements"
            element={<ControlCenterAgreements />}
          />

          {/* SMART OFFER DIGEST */}
          <Route
            path="/control-center/smart-digest"
            element={<ControlCenterSmartDigest />}
          />

          {/* CONTROL CENTER NOTIFICATIONS */}
          <Route
            path="/control-center/notifications"
            element={<ControlCenterNotifications />}
          />
        </Route>

        {/* CUSTOMER FOOD RADAR APP ROUTES */}
        <Route path="/food-radar" element={<FoodRadarHomePage />} />
        <Route path="/food-radar/offers" element={<FoodRadarOffers />} />
        <Route path="/food-radar/rewards" element={<FoodRadarRewards />} />

        {/* NOTIFICATION PICKS LANDING PAGE */}
        <Route
          path="/food-radar/notifications"
          element={<FoodRadarNotificationPicks />}
        />

        {/* FOOD RADAR VENDOR MENU AND ORDER ROUTE */}
        <Route
          path="/food-radar/order/:vendorId"
          element={<FoodRadarOrderForm />}
        />

        {/* INTERNAL PRINT PREVIEW ROUTES */}
        <Route path="/print-preview" element={<PrintPreview />} />
        <Route path="/print-preview.html" element={<PrintPreview />} />

        {/* DELIVERY BOY PUBLIC MOBILE ROUTE */}
        <Route path="/delivery-boy" element={<DeliveryBoyApp />} />

        {/* STAFF PUBLIC LOGIN ROUTE */}
        <Route path="/staff-login" element={<StaffLogin />} />

        {/* Login ke baad /dashboard aaye to OrdersReceived open hoga */}
        <Route
          path="/dashboard"
          element={<Navigate to="/ordersReceived" replace />}
        />

        {/* BUSINESS PAGES */}
        <Route path="/Food" element={<FastFoodPage />} />
        <Route path="/cosmetic" element={<CosmeticPage />} />
        <Route path="/garments" element={<GarmentsPage />} />

        {/* GROCERY ROUTES */}
        <Route path="/grocery-retail" element={<GroceryRetailPage />} />
        <Route path="/grocery-wholesale" element={<GroceryWholesalePage />} />

        {/* QR CODE FUNCTIONALITY */}
        <Route path="/qr-code-display" element={<QrCodeDisplay />} />

        {/* New secure fastfood token QR route */}
        <Route path="/qr-form/:qrToken" element={<StandardQrForm />} />

        {/* Old QR route */}
        <Route path="/qr-form" element={<QrForm />} />

        <Route path="/order-details" element={<OrderDetails />} />
        <Route path="/spin-wheel" element={<SpinWheel />} />
        <Route path="/vendors" element={<VendorPortfolio />} />
        <Route path="/ordersReceived" element={<OrdersReceived />} />
        <Route path="/with_customer" element={<TypeWithCustomer />} />

        {/* VENDOR PAYMENT CENTER */}
        <Route
          path="/VendorPaymentCenter"
          element={<VendorPaymentCenter />}
        />

        {/* ADMIN ROUTES */}
        <Route path="/admin/signup" element={<AdminSignup />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/razorpay" element={<AdminRazorpayPanel />} />

        {/* CAKE PLATFORM ROUTES */}
        <Route path="/cake/signup" element={<CakeSignup />} />
        <Route path="/cake/login" element={<CakeLogin />} />
        <Route path="/cake/book-demo" element={<CakeBookDemo />} />
        <Route path="/cake/vendor" element={<CakeVendorHome />} />
        <Route path="/cake/cakes" element={<CakeProducts />} />
        <Route path="/cake/cakes/add" element={<CakeAddProduct />} />
        <Route path="/cake/orders" element={<CakeOrders />} />
        <Route path="/cake/settings" element={<CakeSettings />} />
        <Route path="/cake/:shopKey/checkout" element={<CakeCheckout />} />
        <Route path="/cake/:shopKey" element={<CakePublicShop />} />

        {/* PUBLIC VENDOR SHORT / FULL NAME ROUTE */}
        <Route
          path="/:shopKey"
          element={<VendorPublicLinkResolver />}
        />

        {/* Unknown / wrong URL */}
        <Route path="*" element={<InvalidQrPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
